module.exports = __webpack_public_path__ + "img/Frente-73-00 off.01c96881.png";